import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppConfig } from '@infodata-group/inf-commons';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  urlBlacklist: string[] = [];

  constructor(private appConfig: AppConfig) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldIntercept(req.url)) {
      // replace api by assets rep
      let mockUrl = req.url.replace(this.appConfig.apiEndPoint, 'assets/');
      // if options, we're looking for the schema
      if (req.method === 'OPTIONS') {
        mockUrl = mockUrl.replace('.json', '.schema.json');
      }
      // return new request
      return next.handle(req.clone({ url: mockUrl, method: 'GET' }));
    }
    return next.handle(req);
  }

  private shouldIntercept(url): boolean {
    return !this.urlBlacklist.includes(url) && url.includes('.json');
  }
}
